import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { TimeType } from "../../../../models/timeType";
import { FilterService } from "../../../../services/filter.service";
import { Helper } from "../../../../shared/helper";

@Component({
  standalone: false,
  selector: "dua-time-picker",
  templateUrl: "./time-picker.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./time-picker.component.scss"],
})
export class TimePickerComponent implements OnInit {
  @Output() closeFilter: EventEmitter<boolean> = new EventEmitter();

  fromDate!: Date;
  fromTime!: Date;
  toDate!: Date;
  toTime!: Date;

  timeType!: number;

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.initiateComponent();
  }

  private initiateComponent() {
    let filter = this.filterService.getFilterCopy();

    this.fromDate = new Date(filter.fromDate) ?? new Date();

    this.fromTime = new Date(filter.fromDate) ?? new Date();

    this.toDate = new Date(filter.toDate) ?? new Date();

    this.toTime = new Date(filter.toDate) ?? new Date();

    this.timeType = filter.timeType.id;
  }

  onTimeTypeChange(timeType: number) {
    this.filterService.setTimeType(new TimeType(timeType, ""));
  }

  onModelChange(value: Date, property: string) {
    if (property === "fromDate" && value) {
      Helper.setDateFromOtherDate(this.fromDate, value);
      this.fromDate.setHours(this.fromTime.getHours());
      this.fromDate.setMinutes(this.fromTime.getMinutes());
    }

    if (property === "fromTime" && value) {
      this.fromTime = new Date(value);
      this.fromDate.setHours(this.fromTime.getHours());
      this.fromDate.setMinutes(this.fromTime.getMinutes());
    }

    if (property === "toDate" && value) {
      Helper.setDateFromOtherDate(this.toDate, value);
      this.toDate.setHours(this.toTime.getHours());
      this.toDate.setMinutes(this.toTime.getMinutes());
    }

    if (property === "toTime" && value) {
      this.toTime = new Date(value);
      this.toDate.setHours(this.toTime.getHours());
      this.toDate.setMinutes(this.toTime.getMinutes());
    }

    Helper.resetSeconds(this.fromDate);
    Helper.resetSeconds(this.toDate);

    this.filterService.setDates(this.fromDate, this.toDate);
  }

  onPickerChange(
    value: Date | null,
    property: "fromDate" | "fromTime" | "toDate" | "toTime"
  ) {
    if (!value) {
      return;
    }
    this.onModelChange(value, property);
  }

  close() {
    this.closeFilter.emit(true);
  }
}
